import { Capacitor } from "@capacitor/core";

const rawEnv =
  (import.meta.env as Record<string, string | undefined>).VITE_ENVIRONMENT ??
  "dev";
const env = rawEnv.toLowerCase();

const isProdEnv = env === "prod" || env === "production";
const isNative = Capacitor.isNativePlatform();
const isAndroid = isNative && Capacitor.getPlatform() === "android";

export const BASE_URL = isProdEnv
  ? "https://api.meemarriage.com"
  : isAndroid
    ? "http://10.0.2.2:3300"
    : "http://localhost:3300";
export const API_BASE_URL = BASE_URL + "/api";
export const UPLOAD_URL = BASE_URL + "/uploads";
export const WEB_URL = BASE_URL;

export const SessionKeys = {
  activeLang: "activeLang",
  sessionToken: "token",
  bureauData: "bureauData",
  profileId: "profileId",
} as const;

export const FEMALE_KEYWORDS = new Set([
  "female",
  "f",
  "woman",
  "women",
  "girl",
  "lady",
  "bride",
  "she",
]);

// Height dropdown options (individual values)
export const heightOptions = [
  { value: "4.0", label: "4'0\" (122 cm)" },
  { value: "4.1", label: "4'1\" (124 cm)" },
  { value: "4.2", label: "4'2\" (127 cm)" },
  { value: "4.3", label: "4'3\" (130 cm)" },
  { value: "4.4", label: "4'4\" (132 cm)" },
  { value: "4.5", label: "4'5\" (135 cm)" },
  { value: "4.6", label: "4'6\" (137 cm)" },
  { value: "4.7", label: "4'7\" (140 cm)" },
  { value: "4.8", label: "4'8\" (142 cm)" },
  { value: "4.9", label: "4'9\" (145 cm)" },
  { value: "4.10", label: "4'10\" (147 cm)" },
  { value: "4.11", label: "4'11\" (150 cm)" },
  { value: "5.0", label: "5'0\" (152 cm)" },
  { value: "5.1", label: "5'1\" (155 cm)" },
  { value: "5.2", label: "5'2\" (157 cm)" },
  { value: "5.3", label: "5'3\" (160 cm)" },
  { value: "5.4", label: "5'4\" (163 cm)" },
  { value: "5.5", label: "5'5\" (165 cm)" },
  { value: "5.6", label: "5'6\" (168 cm)" },
  { value: "5.7", label: "5'7\" (170 cm)" },
  { value: "5.8", label: "5'8\" (173 cm)" },
  { value: "5.9", label: "5'9\" (175 cm)" },
  { value: "5.10", label: "5'10\" (178 cm)" },
  { value: "5.11", label: "5'11\" (180 cm)" },
  { value: "6.0", label: "6'0\" (183 cm)" },
  { value: "6.1", label: "6'1\" (185 cm)" },
  { value: "6.2", label: "6'2\" (188 cm)" },
  { value: "6.3", label: "6'3\" (191 cm)" },
  { value: "6.4", label: "6'4\" (193 cm)" },
  { value: "6.5", label: "6'5\" (196 cm)" },
  { value: "6.6", label: "6'6\" (198 cm)" },
  { value: "6.7", label: "6'7\" (201 cm)" },
  { value: "6.8", label: "6'8\" (203 cm)" },
  { value: "6.9", label: "6'9\" (206 cm)" },
  { value: "6.10", label: "6'10\" (208 cm)" },
  { value: "6.11", label: "6'11\" (211 cm)" },
  { value: "7.0", label: "7'0\" (213 cm)" },
];

export const ageOptions = [
  { value: 18, label: "18 years" },
  { value: 19, label: "19 years" },
  { value: 20, label: "20 years" },
  { value: 21, label: "21 years" },
  { value: 22, label: "22 years" },
  { value: 23, label: "23 years" },
  { value: 24, label: "24 years" },
  { value: 25, label: "25 years" },
  { value: 26, label: "26 years" },
  { value: 27, label: "27 years" },
  { value: 28, label: "28 years" },
  { value: 29, label: "29 years" },
  { value: 30, label: "30 years" },
  { value: 31, label: "31 years" },
  { value: 32, label: "32 years" },
  { value: 33, label: "33 years" },
  { value: 34, label: "34 years" },
  { value: 35, label: "35 years" },
  { value: 36, label: "36 years" },
  { value: 37, label: "37 years" },
  { value: 38, label: "38 years" },
  { value: 39, label: "39 years" },
  { value: 40, label: "40 years" },
  { value: 41, label: "41 years" },
  { value: 42, label: "42 years" },
  { value: 43, label: "43 years" },
  { value: 44, label: "44 years" },
  { value: 45, label: "45 years" },
  { value: 46, label: "46 years" },
  { value: 47, label: "47 years" },
  { value: 48, label: "48 years" },
  { value: 49, label: "49 years" },
  { value: 50, label: "50 years" },
  { value: 51, label: "51 years" },
  { value: 52, label: "52 years" },
  { value: 53, label: "53 years" },
  { value: 54, label: "54 years" },
  { value: 55, label: "55 years" },
  { value: 56, label: "56 years" },
  { value: 57, label: "57 years" },
  { value: 58, label: "58 years" },
  { value: 59, label: "59 years" },
  { value: 60, label: "60 years" },
  { value: 61, label: "61 years" },
  { value: 62, label: "62 years" },
  { value: 63, label: "63 years" },
  { value: 64, label: "64 years" },
  { value: 65, label: "65 years" },
  { value: 66, label: "66 years" },
  { value: 67, label: "67 years" },
  { value: 68, label: "68 years" },
  { value: 69, label: "69 years" },
  { value: 70, label: "70 years" },
  { value: 71, label: "71 years" },
  { value: 72, label: "72 years" },
  { value: 73, label: "73 years" },
  { value: 74, label: "74 years" },
  { value: 75, label: "75 years" },
  { value: 76, label: "76 years" },
  { value: 77, label: "77 years" },
  { value: 78, label: "78 years" },
  { value: 79, label: "79 years" },
  { value: 80, label: "80 years" },
];

export const Age_Preferences = [
  { value: "18_24", label: "18-24" },
  { value: "25_30", label: "25-30" },
  { value: "31_35", label: "31-35" },
  { value: "36_40", label: "36-40" },
  { value: "41_50", label: "41-50" },
  { value: "51_and_above", label: "51 and above" },
];

export const totalPropertyValueOptions = [
  { value: "10 Lakh", label: "10 Lakh" },
  { value: "15 Lakh", label: "15 Lakh" },
  { value: "20 Lakh", label: "20 Lakh" },
  { value: "30 Lakh", label: "30 Lakh" },
  { value: "40 Lakh", label: "40 Lakh" },
  { value: "50 Lakh", label: "50 Lakh" },
  { value: "60 Lakh", label: "60 Lakh" },
  { value: "70 Lakh", label: "70 Lakh" },
  { value: "80 Lakh", label: "80 Lakh" },
  { value: "90 Lakh", label: "90 Lakh" },

  { value: "1 Crore above", label: "1 Crore above" },
  { value: "2 Crore above", label: "2 Crore above" },
  { value: "3 Crore above", label: "3 Crore above" },
  { value: "4 Crore above", label: "4 Crore above" },
  { value: "5 Crore above", label: "5 Crore above" },
  { value: "6 Crore above", label: "6 Crore above" },
  { value: "7 Crore above", label: "7 Crore above" },
  { value: "8 Crore above", label: "8 Crore above" },
  { value: "9 Crore above", label: "9 Crore above" },
  { value: "10 Crore above", label: "10 Crore above" },

  { value: "15 Crore above", label: "15 Crore above" },
  { value: "20 Crore above", label: "20 Crore above" },
  { value: "25 Crore above", label: "25 Crore above" },
  { value: "30 Crore above", label: "30 Crore above" },
  { value: "40 Crore above", label: "40 Crore above" },
  { value: "50 Crore above", label: "50 Crore above" },
  { value: "60 Crore above", label: "60 Crore above" },
  { value: "70 Crore above", label: "70 Crore above" },
  { value: "80 Crore above", label: "80 Crore above" },
  { value: "90 Crore above", label: "90 Crore above" },

  { value: "100 Crore above", label: "100 Crore above" },
  { value: "150 Crore above", label: "150 Crore above" },
  { value: "200 Crore above", label: "200 Crore above" },
  { value: "300 Crore above", label: "300 Crore above" },
  { value: "400 Crore above", label: "400 Crore above" },
  { value: "500 Crore above", label: "500 Crore above" },
  { value: "600 Crore above", label: "600 Crore above" },
  { value: "700 Crore above", label: "700 Crore above" },
  { value: "800 Crore above", label: "800 Crore above" },
  { value: "900 Crore above", label: "900 Crore above" },
  { value: "1000 Crore above", label: "1000 Crore above" },
];
